// extracted by mini-css-extract-plugin
export default {"canvas":"LandingThree_canvas__IrkQM","testest":"LandingThree_testest__0squl","titleText":"LandingThree_titleText__043jb"};